export const ID_TOKEN_KEY = 'idToken';
export const TOKEN_EXPIRE_ON_KEY = 'tokenExpiresOn';
export const ACCESS_TOKEN_KEY ='accessToken';
export const LOGIN_FAIL ='loginFail';
export const REFRESH_TOKEN_KEY ='refreshToken';
export const EXPIRESIN ='expiryTime';
export const BACKBONE_DB_NAME = 'backbone.db';
export const ROLES = 'roles';
